import { render, staticRenderFns } from "./small_center_image.vue?vue&type=template&id=30f4d992&scoped=true&"
import script from "./small_center_image.vue?vue&type=script&lang=js&"
export * from "./small_center_image.vue?vue&type=script&lang=js&"
import style0 from "./small_center_image.vue?vue&type=style&index=0&id=30f4d992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4d992",
  null
  
)

export default component.exports